module.exports = __webpack_public_path__ + "static/media/emagrecentro.cf2e8fa4.png";